"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTvPartnerChannelStencil = exports.tvPartnerChannelStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.tvPartnerChannelStencilDefinition = {
    view: {
        label: 'Partner Channel',
        group: 'Collections',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'featured-media',
                            'logos',
                            'partner-icon',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: ['search-terms', 'standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: properties_1.ctaContainerPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.partnerIconPropertyDefinition.name]: properties_1.partnerIconPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: ['rbtv'],
    name: 'tv-partner-channel',
};
const isTvPartnerChannelStencil = (stencil) => {
    return stencil.name === exports.tvPartnerChannelStencilDefinition.name;
};
exports.isTvPartnerChannelStencil = isTvPartnerChannelStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHYtcGFydG5lci1jaGFubmVsLnN0ZW5jaWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RlbmNpbHMvdHYtcGFydG5lci1jaGFubmVsLnN0ZW5jaWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsOENBdUJzQjtBQUVULFFBQUEsaUNBQWlDLEdBQUc7SUFDL0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixLQUFLLEVBQUUsYUFBYTtRQUNwQixVQUFVLEVBQUUsQ0FBQyxPQUFPLENBQUM7UUFDckIsVUFBVSxFQUFFLENBQUMsZ0JBQWdCLENBQUM7UUFDOUIsWUFBWSxFQUFFO1lBQ1o7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osS0FBSyxFQUFFO29CQUNMLGNBQWM7b0JBQ2QsT0FBTztvQkFDUCxZQUFZO29CQUNaLFFBQVE7aUJBQ1Q7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLFFBQVEsRUFBRTtvQkFDUjt3QkFDRSxJQUFJLEVBQUUsU0FBUzt3QkFDZixLQUFLLEVBQUU7NEJBQ0wsV0FBVzs0QkFDWCxjQUFjOzRCQUNkLGdCQUFnQjs0QkFDaEIsV0FBVzs0QkFDWCxnQkFBZ0I7NEJBQ2hCLE9BQU87NEJBQ1AsY0FBYzt5QkFDZjtxQkFDRjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsS0FBSzt3QkFDWCxLQUFLLEVBQUUsQ0FBQyxlQUFlLENBQUM7cUJBQ3pCO29CQUNEO3dCQUNFLElBQUksRUFBRSxVQUFVO3dCQUNoQixLQUFLLEVBQUUsQ0FBQyxjQUFjLEVBQUUsWUFBWSxDQUFDO3FCQUN0QztvQkFDRDt3QkFDRSxJQUFJLEVBQUUsbUJBQW1CO3dCQUN6QixLQUFLLEVBQUUsQ0FBQyxzQkFBc0IsQ0FBQztxQkFDaEM7aUJBQ0Y7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxTQUFTO2dCQUNmLEtBQUssRUFBRTtvQkFDTCxhQUFhO29CQUNiLG9CQUFvQjtvQkFDcEIsWUFBWTtvQkFDWixrQkFBa0I7b0JBQ2xCLGFBQWE7b0JBQ2IsV0FBVztvQkFDWCxpQkFBaUI7aUJBQ2xCO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsQ0FBQyxnREFBbUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxnREFBbUM7UUFDL0UsQ0FBQywyQ0FBOEIsQ0FBQyxJQUFJLENBQUMsRUFBRSwyQ0FBOEI7UUFDckUsQ0FBQywwQ0FBNkIsQ0FBQyxJQUFJLENBQUMsRUFBRSwwQ0FBNkI7UUFDbkUsQ0FBQyw0Q0FBK0IsQ0FBQyxJQUFJLENBQUMsRUFBRSw0Q0FBK0I7UUFDdkUsQ0FBQyw0Q0FBK0IsQ0FBQyxJQUFJLENBQUMsRUFBRSw0Q0FBK0I7UUFDdkUsQ0FBQywwQ0FBNkIsQ0FBQyxJQUFJLENBQUMsRUFBRSwwQ0FBNkI7UUFDbkUsQ0FBQyxvQ0FBdUIsQ0FBQyxJQUFJLENBQUMsRUFBRSxvQ0FBdUI7UUFDdkQsQ0FBQywwQ0FBNkIsQ0FBQyxJQUFJLENBQUMsRUFBRSwwQ0FBNkI7UUFDbkUsQ0FBQyxrREFBcUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxrREFBcUM7UUFDbkYsQ0FBQyw2Q0FBZ0MsQ0FBQyxJQUFJLENBQUMsRUFBRSw2Q0FBZ0M7UUFDekUsQ0FBQywwQ0FBNkIsQ0FBQyxJQUFJLENBQUMsRUFBRSwwQ0FBNkI7UUFDbkUsQ0FBQyx1Q0FBMEIsQ0FBQyxJQUFJLENBQUMsRUFBRSx1Q0FBMEI7UUFDN0QsQ0FBQywwQ0FBNkIsQ0FBQyxJQUFJLENBQUMsRUFBRSwwQ0FBNkI7UUFDbkUsQ0FBQyx5Q0FBNEIsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUNuQyxHQUFHLHlDQUE0QjtZQUMvQixPQUFPLEVBQUUsSUFBSTtTQUNkO1FBQ0QsQ0FBQyx5Q0FBNEIsQ0FBQyxJQUFJLENBQUMsRUFBRSx5Q0FBNEI7UUFDakUsQ0FBQyx3Q0FBMkIsQ0FBQyxJQUFJLENBQUMsRUFBRSx3Q0FBMkI7UUFDL0QsQ0FBQyw2Q0FBZ0MsQ0FBQyxJQUFJLENBQUMsRUFBRSw2Q0FBZ0M7UUFDekUsQ0FBQyx5Q0FBNEIsQ0FBQyxJQUFJLENBQUMsRUFBRSx5Q0FBNEI7UUFDakUsQ0FBQyx1Q0FBMEIsQ0FBQyxJQUFJLENBQUMsRUFBRSx1Q0FBMEI7UUFDN0QsQ0FBQyxvQ0FBdUIsQ0FBQyxJQUFJLENBQUMsRUFBRSxvQ0FBdUI7UUFDdkQsQ0FBQyxxQ0FBd0IsQ0FBQyxJQUFJLENBQUMsRUFBRSxxQ0FBd0I7UUFDekQsQ0FBQyx1Q0FBMEIsQ0FBQyxJQUFJLENBQUMsRUFBRSx1Q0FBMEI7S0FDOUQ7SUFDRCxhQUFhLEVBQUUsRUFBRTtJQUNqQixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxDQUFDLE1BQU0sQ0FBQztJQUNoQixJQUFJLEVBQUUsb0JBQW9CO0NBQ0ksQ0FBQTtBQUl6QixNQUFNLHlCQUF5QixHQUFHLENBQUMsT0FBb0IsRUFBc0MsRUFBRTtJQUNwRyxPQUFPLE9BQU8sQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQ2hFLENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9